module.exports = require('./colorbrewer.js');



//////////////////
// WEBPACK FOOTER
// ./~/colorbrewer/index.js
// module id = 1015
// module chunks = 6